<template>
  <div class="login-box">
    <div class="login-pannel">
      <div class="login-pannel-title">
        <span>济南管片数字大屏-运维系统</span>
      </div>
      <div class="login-pannel-form">
        <el-form ref="form" :rules="rules" :model="ruleForm">
          <div style="margin-bottom: 40px">
            <el-form-item prop="username">
              <el-input
                v-model="ruleForm.username"
                size="big"
                clearable
                placeholder="请输入用户名"
                prefix-icon="el-icon-user-solid">
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                v-model="ruleForm.password"
                size="big"
                clearable
                placeholder="请输入密码"
                show-password
                prefix-icon="el-icon-s-goods">
              </el-input>
            </el-form-item>
          </div>
          <el-button class="form_button" size="big" type="primary" @click="onLogin">登录</el-button>
        </el-form>
      </div>
      <div class="login-pannel-agreement">
        <span
          >登录代表你已经同意<span class="sty1">《用户协议》</span>和<span class="sty1"
            >《隐私权政策》</span
          ></span
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ruleForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          {
            required: true,
            message: '请输入用户名',
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  beforeCreate() {
    this.$http = this.$api.screenCms.InitialPort
  },
  created() {},
  methods: {
    //获取信息
    onLogin() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.$http.login(this.ruleForm).then(res => {
          if (res.statusMsg === 'ok') {
            sessionStorage.setItem('token', res.data.token)
            sessionStorage.setItem('screenCmsLists', JSON.stringify(res.data.menus))
            this.$message.success('登录成功')
            this.$router.push('ScreenCmsHome')
          } else {
            this.$message.warning(res.statusMsg)
          }
        })
      })
    }
  }
}
</script>
<style scoped lang="scss">
.login-box {
  position: absolute;
  width: 100%;
  height: 100%;
  text-align: center;
  background: url('../../assets/opration/sc_login_bg.png') top -70px center no-repeat;
  background-color: #153169;

  .login-pannel {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    position: absolute;
    left: 5%;
    bottom: 5%;
    width: 90%;
    height: 360px;
    padding: 20px;
    margin: auto;
    text-align: center;
    background-color: #fff;
    border-radius: 20px;

    .login-pannel-title {
      color: #0873ff;
      font-weight: bold;
      font-size: 20px;
      margin-bottom: 26px;
    }

    .login-pannel-form {
      .form_button {
        width: 100%;
        background: linear-gradient(-45deg, #556dfe 0%, #237eff 100%);
      }
    }

    .login-pannel-agreement {
      font-size: 12px;
      margin-top: 20px;
      color: #666666;

      .sty1 {
        color: #0873ff;
      }
    }
  }
}

@media only screen and (min-width: 600px) {
  .login-box {
    position: absolute;
    width: 600px;
    left: 50%;
    background: url('../../assets/opration/sc_login_bg.png') center -150px no-repeat;
    background-size: 84% auto;
    background-color: #153169;
    transform: translateX(-50%);
    .login-pannel {
      .login-pannel-title {
        font-size: 26px;
      }
      height: 430px;
      /deep/ .el-input__inner {
        height: 46px;
      }
      .el-button {
        height: 46px;
      }
    }
  }
}
</style>
